module.exports = __webpack_public_path__ + "static/media/energia.a4a58a7f.png";